var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8874 12.5941L19.8315 6.65005C20.053 6.42406 20.1763 6.11981 20.1747 5.8034C20.1731 5.487 20.0467 5.18401 19.823 4.96027C19.5992 4.73653 19.2962 4.61013 18.9798 4.60854C18.6634 4.60694 18.3592 4.73027 18.1332 4.95174L12.1891 10.8958L6.24502 4.95174C6.01903 4.73027 5.71478 4.60694 5.39837 4.60854C5.08197 4.61013 4.77898 4.73653 4.55524 4.96027C4.33151 5.18401 4.2051 5.487 4.20351 5.8034C4.20191 6.11981 4.32524 6.42406 4.54671 6.65005L10.4908 12.5941L4.54671 18.5382C4.32524 18.7642 4.20191 19.0685 4.20351 19.3849C4.2051 19.7013 4.33151 20.0043 4.55524 20.228C4.77898 20.4517 5.08197 20.5781 5.39837 20.5797C5.71478 20.5813 6.01903 20.458 6.24502 20.2365L12.1891 14.2924L18.1332 20.2365C18.3592 20.458 18.6634 20.5813 18.9798 20.5797C19.2962 20.5781 19.5992 20.4517 19.823 20.228C20.0467 20.0043 20.1731 19.7013 20.1747 19.3849C20.1763 19.0685 20.053 18.7642 19.8315 18.5382L13.8874 12.5941Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.de394e094ae22164d708d29cee09b0e2.svg";
export { ForwardRef as ReactComponent };